import { httpClient } from "@/utils/api"
import type { SuccessData } from "@/utils/api"
import type { UseMutationOptions } from "@tanstack/react-query"
import type { AxiosError, AxiosResponse } from "axios"

import type { UserMutationError } from "./use-user-mutation"
import { useUserMutation } from "./use-user-mutation"

export type DeleteUserError = UserMutationError

const deleteUserApi = async ({
  userId,
}: {
  userId: string
}): Promise<AxiosResponse<SuccessData>> => {
  const response = await httpClient.delete<SuccessData>(
    `/api/v1/users/${userId}`
  )

  return response
}

export const useDeleteUser = (
  options?: UseMutationOptions<
    AxiosResponse<SuccessData>,
    AxiosError<DeleteUserError>,
    { userId: string }
  >
) =>
  useUserMutation({
    mutationFn: deleteUserApi,
    resultKey: "deleteUser",
    fallbackErrorMessage: "deleteUser.deleteUserError",
    options,
  })
